export default function Problem() {
  return (
    <section
      data-testid="problem-section"
      className="bg-[#F8F9FA] border-y-2 border-[#1A1A1A] relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-dots opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-5xl px-5 md:px-10 lg:px-12 py-20 md:py-28 text-center">
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#FF007F]">
          The Problem
        </p>
        <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
          The world has changed.{" "}
          <span className="relative inline-block">
            <span className="relative z-10">Learning has to shift.</span>
            <span className="absolute left-0 right-0 bottom-1 h-3 md:h-4 bg-[#00C2B8] -z-0 rounded-sm" />
          </span>
        </h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto">
          <p className="text-base md:text-lg text-[#1A1A1A] font-medium leading-relaxed">
            The world of work has changed. Schools and libraries know young
            people need more than content knowledge — they need confidence,
            creativity, adaptability and real-world problem-solving skills.
          </p>
          <p className="text-base md:text-lg text-[#4A4A4A] font-medium leading-relaxed">
            But most organisations don’t need more random tech. They need a
            clear framework, confident educators, more community and
            connection, and a practical pathway from ideas to implementation.
          </p>
        </div>
      </div>
    </section>
  );
}
